import React, { useEffect, useState } from 'react'
import { Select2 } from '@blueprintjs/select'
import { NumericInput, MenuItem, FormGroup } from '@blueprintjs/core'
import { Button } from '@ui'
import { startCase } from 'lodash'

interface LengthOption {
  name: 'Days' | 'Weeks' | 'Months'
  value: 'days' | 'weeks' | 'months'
}

const lengthOptions: LengthOption[] = [
  { name: 'Days', value: 'days' },
  { name: 'Weeks', value: 'weeks' },
  { name: 'Months', value: 'months' },
]

interface TimeCountSelectorProps {
  value: { [type: string]: number }
  onChange: (data: { [type: string]: number }) => void
  maximums: { days: number; weeks: number; months: number }
}

const TimeSelect = Select2<LengthOption>

export default function TimeCountSelector({ value, onChange, maximums }: TimeCountSelectorProps) {
  const [option, setOption] = useState(value)
  const [minMaxError, setMinMaxError] = useState(false)
  const [decimalError, setDecimalError] = useState(false)
  const key = Object.keys(option)[0] as 'days' | 'weeks' | 'months'

  useEffect(() => {
    if (
      value[key] !== option[key] &&
      option[key] <= maximums[key] &&
      option[key] > 0 &&
      !String(option[key]).includes('.')
    )
      onChange(option)
  }, [value, onChange, option, maximums, key])

  const currentMax = maximums[Object.keys(option)[0] as 'days' | 'weeks' | 'months']
  const [inputValue, setInputValue] = useState(Object.values(option)[0]?.toString())
  return (
    <div className="flex">
      <FormGroup
        intent={minMaxError || decimalError ? 'danger' : 'none'}
        helperText={
          minMaxError
            ? `Value must be between 1 and ${currentMax}`
            : decimalError
            ? 'Decimals Not Allowed'
            : `(Max: ${currentMax} ${key})`
        }>
        <NumericInput
          onValueChange={(valueAsNumber, valueAsString) => {
            if (valueAsString === '' || valueAsNumber > maximums[key]) {
              setMinMaxError(true)
            } else if (valueAsString.includes('.')) {
              setDecimalError(true)
            } else if (decimalError) {
              setDecimalError(false)
            } else if (minMaxError) {
              setMinMaxError(false)
            }
            setInputValue(valueAsString)
            if (valueAsNumber <= maximums[key] && valueAsNumber > 0)
              setOption({ [Object.keys(option)[0]]: valueAsNumber })
          }}
          value={inputValue}
          max={currentMax}
          min={1}
          allowNumericCharactersOnly
          buttonPosition="none"
          clampValueOnBlur
        />
      </FormGroup>
      <TimeSelect
        items={lengthOptions}
        popoverProps={{ minimal: true }}
        itemRenderer={(i, { handleClick }) => (
          <MenuItem key={i.name} text={i.name} onClick={handleClick} />
        )}
        filterable={false}
        onItemSelect={(i) => {
          setOption({ [i.value]: 1 })
        }}>
        <Button
          text={startCase(Object.keys(option)[0] as 'days' | 'weeks' | 'months')}
          style={{ marginLeft: 10 }}
          rightIconName="chevron-down"
        />
      </TimeSelect>
    </div>
  )
}
